import { Injectable } from '@angular/core';
import { ShoppingListPermission } from '../../model';
import { Occ } from '../../occ/occ-models';
import { Converter } from '../../util';

@Injectable({ providedIn: 'root' })
export class ShoppingListPermissionsSerializer
  implements Converter<ShoppingListPermission[], Occ.PrincipalSharedCartTemplateFlags[]>
{
  convert(
    source: ShoppingListPermission[],
    target?: Occ.PrincipalSharedCartTemplateFlags[]
  ): Occ.PrincipalSharedCartTemplateFlags[] {
    if (source) {
      target = this.convertPermissions(source);
    }

    return target;
  }

  private convertPermissions(source: ShoppingListPermission[]): Occ.PrincipalSharedCartTemplateFlags[] {
    return source ? source.map((permission) => this.convertPermission(permission)) : [];
  }

  private convertPermission(source: ShoppingListPermission): Occ.PrincipalSharedCartTemplateFlags {
    if (source) {
      const { uid, ...target } = source;
      return {
        ...target,
        principal: {
          uid,
        },
      };
    } else {
      return undefined;
    }
  }
}
